export default "__VITE_ASSET__nkgbpwzb__"